import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  datePicker: {
    minWidth: "100%",
    marginTop: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "10px",
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
      paddingTop: "5px",
    },
  },
  showGraphButton: {
    minWidth: "75%",
    marginTop: theme.spacing(3),
  },
  centerSelection: {
    alignSelf: "center",
  },
  showSelectAllButton: {
    minWidth: "100%",
    marginTop: theme.spacing(2),

  },
  onlyPrint: {
    display: 'none'
  },
  print: { pageBreakAfter: 'always' },
  noPrint: {},
  paper: {
    padding: theme.spacing(2),
    marginRight: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height: "100%",
  },
  printDetails: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  '@media print': {
    '@page': { margin: 0 },
    print: {
      display: 'block !important'
    },
    onlyPrint: { display: 'block !important' },
    noPrint: { display: 'none !important' }
  },
  textFieldRoot: {
    "& > div.MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      // default paddingRight was 39px since clear icon was positioned absolute
      paddingRight: "9px",
      fontSize: "0.9rem",

      // Search icon
      "& button": {
        order: 3, // order 3 means the search icon will appear after the clear icon which has an order of 2
        fontSize: "0.9rem"
      },
      // Clear icon
      "& > div.MuiAutocomplete-endAdornment": {
        position: "relative", // default was absolute. we make it relative so that it is now within the flow of the other two elements
        order: 2,
      },
    },
  },
  zugeordnetStyle: {
    marginLeft: "auto",
    marginRight: "0",
    marginTop: "6px",
  }
}), { index: 1 });
